import { Helmet } from 'react-helmet-async';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { MIN_PASSWORD_LENGTH } from '@e-socna/users';

import { PasswordChangeForm } from '../../forms/PasswordChange';
import { useLogout } from '../../hooks/useLogout.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';

// Shown instead of the application while the password of the user was set by
// someone else (seeded, regenerated).
export const PasswordChangePage = () => {
  const logout = useLogout();

  return (
    <Stack spacing={3} sx={{ maxWidth: 480, width: '100%' }}>
      <Helmet>
        <title>{buildDocumentTitle('Changement du mot de passe')}</title>
      </Helmet>
      <Typography component="h1" sx={{ textAlign: 'center' }} variant="h4">
        Changement du mot de passe
      </Typography>
      <Typography>
        Votre mot de passe vous a été communiqué : choisissez-en un nouveau,
        d&apos;au moins {MIN_PASSWORD_LENGTH} caractères, avant d&apos;accéder à
        e-SOCNA.
      </Typography>
      <PasswordChangeForm />
      <Button onClick={logout} size="large">
        Se déconnecter
      </Button>
    </Stack>
  );
};
